import React from "react";
import { Card } from "react-bootstrap";

interface Props {
  title?: string;
  children?: React.ReactNode;
  headerClass?: string;
}

const ApprovalCard = ({ title, children, headerClass }: Props) => (
  <Card className="mb-4">
    {title && (
      <Card.Header className={headerClass || "bg-light"}>{title}</Card.Header>
    )}
    <Card.Body>{children}</Card.Body>
  </Card>
);

export default ApprovalCard;
